import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getHeaders } from '../utils/headers.functions';

const BASE_URL: string = environment.API_URL;
const httpOptions: HttpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
@Injectable({
  providedIn: 'root',
})
export class CampaignService {
  constructor(private http: HttpClient) {}

  createCampaign(campaignData: any): Observable<any> {
    const headers: HttpHeaders = getHeaders();
    return this.http.post(`${BASE_URL}/scheduleCampaign`, campaignData, { headers });
  }

  sendEmail(emailData: any): Observable<any> {
    return this.http.post(`${BASE_URL}/sendEmail`, emailData);
  }

  // Otros métodos para crear contactos, listas, etc.
}
